import React, { useState, useEffect, useCallback } from 'react';
import { staffApi, attendanceApi } from '../api/client';
import { Spin, useFlash } from '../components/UI';
import { Download } from '../components/Icons';

const MNF = ['January','February','March','April','May','June',
             'July','August','September','October','November','December'];
const MN  = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

const fmt = n => '₹' + Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 });

function calcWages(staffId, dailyRate, attData) {
  const rate = Number(dailyRate) || 0;
  let full = 0, half = 0;
  attData.filter(r => r.staff_id === staffId).forEach(r => {
    if (r.status === 'present')  full++;
    if (r.status === 'half_day') half++;
  });
  const payable = full * rate + half * (rate / 2);
  return { full, half, payable };
}

function printSalarySheet(rows, month, year) {
  const monthLabel = `${MNF[month - 1]} ${year}`;
  const rowsHtml = rows.map((r, i) => `
    <tr>
      <td style="padding:8px;border:1px solid #ddd;text-align:center">${i + 1}</td>
      <td style="padding:8px;border:1px solid #ddd;font-weight:600">${r.name}</td>
      <td style="padding:8px;border:1px solid #ddd;text-align:right">${fmt(r.daily_rate)}</td>
      <td style="padding:8px;border:1px solid #ddd;text-align:center;color:#16a34a;font-weight:700">${r.full}</td>
      <td style="padding:8px;border:1px solid #ddd;text-align:center;color:#b45309;font-weight:700">${r.half}</td>
      <td style="padding:8px;border:1px solid #ddd;text-align:center;color:#dc2626;font-weight:700">${r.effectiveDays.toFixed(1)}</td>
      <td style="padding:8px;border:1px solid #ddd;text-align:right;font-weight:700;color:#1e3a5f">${fmt(r.payable)}</td>
      <td style="padding:8px;border:1px solid #ddd;text-align:center">___________</td>
    </tr>`).join('');

  const total = rows.reduce((s, r) => s + r.payable, 0);

  const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"/>
<title>Daily Wages — ${monthLabel}</title>
<style>
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:Arial,sans-serif;font-size:13px;color:#111;padding:30px 40px;max-width:900px;margin:0 auto}
.hdr{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #1e3a5f;padding-bottom:14px;margin-bottom:22px}
.co{font-size:22px;font-weight:900;color:#1e3a5f;letter-spacing:1px}
.co-sub{font-size:12px;color:#555;margin-top:2px}
.co-right{text-align:right;font-size:11px;color:#333;line-height:1.7}
h2{text-align:center;font-size:17px;font-weight:700;letter-spacing:1px;margin:10px 0 20px;text-transform:uppercase}
table{width:100%;border-collapse:collapse;font-size:12.5px;margin-bottom:20px}
thead tr{background:#1e3a5f;color:#fff}
th{padding:9px 8px;text-align:center;border:1px solid #1e3a5f}
.total-row td{background:#f3f4f6;font-weight:700;font-size:13px;border-top:2px solid #1e3a5f}
.foot{margin-top:20px;border-top:1px solid #ccc;padding-top:12px;font-size:11px;color:#555;text-align:center}
@media print{body{padding:15px 20px}}
</style></head><body>
<div class="hdr">
  <div><div class="co">SAKTHI INVERTERS</div><div class="co-sub">Since 1995</div></div>
  <div class="co-right"><strong>AMBALATH ENTERPRISES</strong><br/>GSTIN: 32AFNPN5476M1ZT<br/>East Nada, Kandiyoor, Mavelikara — 690103</div>
</div>
<h2>Daily Wages Salary Sheet — ${monthLabel}</h2>
<table>
  <thead>
    <tr>
      <th style="width:40px">#</th>
      <th style="text-align:left;padding-left:10px">Staff Name</th>
      <th>Daily Rate</th>
      <th>Full Days</th>
      <th>Half Days</th>
      <th>Effective Days</th>
      <th>Amount Payable</th>
      <th>Signature</th>
    </tr>
  </thead>
  <tbody>
    ${rowsHtml}
    <tr class="total-row">
      <td colspan="6" style="padding:9px 8px;text-align:right;border:1px solid #ddd">Total Payable</td>
      <td style="padding:9px 8px;text-align:right;border:1px solid #ddd;color:#1e3a5f">${fmt(total)}</td>
      <td style="border:1px solid #ddd"></td>
    </tr>
  </tbody>
</table>
<div class="foot">
  Generated on ${new Date().toLocaleDateString('en-IN', { weekday:'long', year:'numeric', month:'long', day:'numeric' })} &nbsp;|&nbsp; Sakthi Solar Solutions ERP &nbsp;|&nbsp; Developed by Data Systems Intelligence Pvt Ltd
</div>
<script>window.onload=function(){window.print();}</script>
</body></html>`;

  const win = window.open('', '_blank');
  win.document.write(html);
  win.document.close();
}

export default function DailyWagesSalary() {
  const { Flash } = useFlash();
  const now = new Date();
  const [year, setYear]     = useState(now.getFullYear());
  const [month, setMonth]   = useState(now.getMonth() + 1);
  const [staff, setStaff]   = useState([]);
  const [attData, setAttData] = useState([]);
  const [staffBusy, setStaffBusy] = useState(true);
  const [attBusy, setAttBusy]   = useState(false);

  useEffect(() => {
    staffApi.list()
      .then(({ data }) => setStaff(data.filter(s => s.is_active && s.pay_type === 'daily_wages')))
      .catch(() => {})
      .finally(() => setStaffBusy(false));
  }, []);

  const loadAtt = useCallback((y, m) => {
    setAttBusy(true);
    attendanceApi.list({ year: y, month: m })
      .then(({ data }) => setAttData(data))
      .catch(() => {})
      .finally(() => setAttBusy(false));
  }, []);

  useEffect(() => { loadAtt(year, month); }, [year, month, loadAtt]);

  const prevMonth = () => {
    if (month === 1) { setYear(y => y - 1); setMonth(12); }
    else setMonth(m => m - 1);
  };
  const nextMonth = () => {
    if (month === 12) { setYear(y => y + 1); setMonth(1); }
    else setMonth(m => m + 1);
  };

  const rows = staff.map(s => {
    const { full, half, payable } = calcWages(s.id, s.daily_rate, attData);
    return { ...s, full, half, effectiveDays: full + half * 0.5, payable };
  });

  const totalPayable = rows.reduce((s, r) => s + r.payable, 0);

  if (staffBusy) return <Spin label="Loading staff…"/>;

  return (
    <div>
      <Flash/>

      {/* Month nav */}
      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:20, background:'var(--card)', borderRadius:10, padding:'10px 16px', border:'1px solid var(--border)' }}>
        <button className="btn btn-sm" onClick={prevMonth}>‹ Prev</button>
        <span style={{ fontWeight:700, fontSize:16, minWidth:140, textAlign:'center' }}>{MNF[month-1]} {year}</span>
        <button className="btn btn-sm" onClick={nextMonth}>Next ›</button>
        {attBusy && <span style={{ fontSize:12, color:'var(--text2)', marginLeft:8 }}>Loading…</span>}
        {rows.length > 0 && (
          <button className="btn btn-sm btn-primary" style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:6 }}
            onClick={() => printSalarySheet(rows, month, year)}>
            <Download s={13}/> Print Salary Sheet
          </button>
        )}
      </div>

      {staff.length === 0 ? (
        <div className="card" style={{ padding:40, textAlign:'center', color:'var(--text2)' }}>
          <div style={{ fontSize:15, fontWeight:600, marginBottom:8 }}>No daily wages staff found.</div>
          <div style={{ fontSize:13 }}>Go to Staff Management and set a staff member's pay type to "Daily Wages" to see them here.</div>
        </div>
      ) : (
        <>
          {/* Summary stat cards */}
          <div className="stat-grid" style={{ gridTemplateColumns:'repeat(3,1fr)', marginBottom:16 }}>
            <div className="stat-card">
              <div className="stat-lbl">Daily Wages Staff</div>
              <div className="stat-val">{staff.length}</div>
            </div>
            <div className="stat-card">
              <div className="stat-lbl">Total Payable</div>
              <div className="stat-val" style={{ color:'var(--navy)', fontSize:20 }}>{fmt(totalPayable)}</div>
              <div className="stat-sub">{MN[month-1]} {year}</div>
            </div>
            <div className="stat-card">
              <div className="stat-lbl">Attendance Loaded</div>
              <div className="stat-val" style={{ color:'var(--green)' }}>{attData.length}</div>
              <div className="stat-sub">records this month</div>
            </div>
          </div>

          {/* Breakdown table */}
          <div className="card card-0">
            <table>
              <thead>
                <tr>
                  <th style={{ textAlign:'left', padding:'9px 14px' }}>Staff Name</th>
                  <th style={{ textAlign:'right' }}>Daily Rate</th>
                  <th style={{ textAlign:'center', color:'var(--green)' }}>Full Days</th>
                  <th style={{ textAlign:'center', color:'#b45309' }}>Half Days</th>
                  <th style={{ textAlign:'center' }}>Effective Days</th>
                  <th style={{ textAlign:'center', color:'var(--red)' }}>Absent</th>
                  <th style={{ textAlign:'right', color:'var(--navy)' }}>Amount Payable</th>
                </tr>
              </thead>
              <tbody>
                {rows.map(s => {
                  const absent = attData.filter(r => r.staff_id === s.id && r.status === 'absent').length;
                  return (
                    <tr key={s.id} style={{ borderBottom:'1px solid var(--border)' }}>
                      <td style={{ padding:'10px 14px', fontWeight:600 }}>{s.name}</td>
                      <td style={{ textAlign:'right', fontSize:13 }}>{fmt(s.daily_rate)}/day</td>
                      <td style={{ textAlign:'center', fontWeight:700, color:'var(--green)' }}>{s.full}</td>
                      <td style={{ textAlign:'center', fontWeight:700, color:'#b45309' }}>{s.half || '—'}</td>
                      <td style={{ textAlign:'center', fontWeight:600 }}>{s.effectiveDays.toFixed(1)}</td>
                      <td style={{ textAlign:'center', fontWeight:700, color: absent > 0 ? 'var(--red)' : 'var(--text2)' }}>{absent || '—'}</td>
                      <td style={{ textAlign:'right', fontWeight:700, fontSize:14, color:'var(--navy)' }}>{fmt(s.payable)}</td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr style={{ borderTop:'2px solid var(--border)', background:'var(--surface)' }}>
                  <td colSpan={6} style={{ padding:'10px 14px', fontWeight:700, textAlign:'right', color:'var(--text2)' }}>Total Payable for {MNF[month-1]} {year}</td>
                  <td style={{ textAlign:'right', fontWeight:800, fontSize:15, color:'var(--navy)', padding:'10px 14px' }}>{fmt(totalPayable)}</td>
                </tr>
              </tfoot>
            </table>
            <div style={{ padding:'10px 16px', fontSize:11, color:'var(--text2)', borderTop:'1px solid var(--border)' }}>
              Effective Days = Full Days + (Half Days × 0.5) &nbsp;|&nbsp; Payable = Effective Days × Daily Rate
            </div>
          </div>
        </>
      )}
    </div>
  );
}
